<template>
  <div class="row-top">
    <p
      v-if="!foundObject"
      class="color-red"
    >
      Keine eindeutigen Treffer gefunden.<br>
      Alle Objekte werden angezeigt.
    </p>
    <div class="row">
      <table class="table mRight table-ex">
        <thead class="table-header">
          <tr>
            <th
              class="table-header"
              width="70"
            >
              #
            </th>
            <th class="table-header">
              Objekt-Nummer
            </th>
            <th class="table-header">
              Straße
            </th>
            <th
              class="table-header"
              width="100"
            >
              Hausnr.
            </th>
            <th class="table-header">
              Postleitzahl
            </th>
            <th class="table-header">
              Stadt
            </th>
            <th class="table-header">
              Bundesland
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="prop in propList"
            :key="prop.id"
            class="table-row"
            :class="{ picked: pickedProp.id === prop.id}"
            @click="pick(prop)"
          >
            <th width="70">
              {{ prop.id }}
            </th>
            <td>{{ prop.property_nr }}</td>
            <td>{{ prop.street }}</td>
            <td>{{ prop.hsnr }}</td>
            <td>{{ prop.zip }}</td>
            <td>{{ prop.city }}</td>
            <td>{{ prop.county }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <PropPreview :property="pickedProp"></PropPreview>
  </div>
</template>
<script>
import PropPreview from './PropPreview.vue'
export default {
  components: {
    PropPreview
  },
  props: {
    propList: {
			type: Array,
			required: true
		},
    foundObject: {
			type: Boolean,
			required: true
		}
  },
  data () {
    return {
      pickedProp: {}
    }
  },
  mounted () {
  },
  methods: {
    pick (prop) {
      localStorage.setItem('prop_id', prop.id)
      this.pickedProp = prop
    }
  }
}
</script>
<style>
</style>
